<template>
	<div>
		<v-toolbar flat color="white">
			<div class="space" style="width:100%">
				<div class="mt-2">
					<v-radio-group v-model="selectedStatus" row>
						<v-radio
							v-for="text in [ACTIVE, INACTIVE]"
							:key="text"
							:label="text"
							:value="text"
							@change="handleStatusChange"
						></v-radio>
					</v-radio-group>
				</div>
				<div class="pa-1" @click="openDialog(false, defaultPayload)">
					<v-btn color="info">Add Leaderboard</v-btn>
				</div>
			</div>
		</v-toolbar>
		<v-container>
			<v-expansion-panel>
				<v-expansion-panel-content
					v-for="item in leaderboardData"
					:key="item.updatedOn"
				>
					<template v-slot:header>
						<div>{{ item.displayName }}</div>
					</template>
					<v-card>
						<div class="space">
							<div style="margin-left:16px">
								<span class="font-weight-bold"
									>Display Name:</span
								>
								{{ item.displayName }}
							</div>
							<div class="mr-4" @click="openDialog(true, item)">
								<v-icon color="#000" style="cursor: pointer"
									>chevron_edit</v-icon
								>
							</div>
						</div>
						<v-card-text
							><span class="font-weight-bold"
								>Leaderboard Name:</span
							>
							{{ item.leaderboardName }}</v-card-text
						>
						<v-card-text
							><span class="font-weight-bold">Description:</span>
							{{ item.description }}</v-card-text
						>
						<v-card-text
							><span class="font-weight-bold">Start Time:</span>
							{{ item.startTime }}</v-card-text
						>
						<v-card-text
							><v-expansion-panel
								><v-expansion-panel-content
									><template v-slot:header>
										<div class="font-weight-bold">
											Prizes
										</div>
									</template>
									<div>
										<v-card
											v-for="(key, i) in Object.keys(
												item.prize || {}
											)"
											:key="i"
											class="mt-2"
										>
											<div class="pa-1">
												<span class="font-weight-bold"
													>Prize:</span
												>
												{{ item.prize[key].prize }}
											</div>
											<div class="pa-1">
												<span class="font-weight-bold"
													>Image:</span
												>
												{{ item.prize[key].image }}
											</div>
										</v-card>
									</div>
								</v-expansion-panel-content></v-expansion-panel
							></v-card-text
						>
						<v-card-text
							><v-expansion-panel
								><v-expansion-panel-content
									><template v-slot:header>
										<div class="font-weight-bold">
											Query
										</div>
									</template>
									<div>
										<div class="pa-1">
											<span class="font-weight-bold"
												>SQL:</span
											>
											{{ item.query.sql }}
										</div>
										<div
											v-if="
												item.query.params &&
													item.query.params.length
											"
											class="font-weight-bold"
										>
											Params:
										</div>
										<v-card
											v-for="(param, i) in item.query
												.params || []"
											:key="i"
											class="mt-2"
										>
											<div class="pa-1">
												<span class="font-weight-bold"
													>{{ param.key }}:</span
												>
												{{ param.value }}
											</div>
										</v-card>
									</div>
								</v-expansion-panel-content></v-expansion-panel
							>
						</v-card-text>
						<v-card-text
							><span class="font-weight-bold">Frequency:</span>
							{{ item.frequency }}</v-card-text
						>
						<v-card-text
							><span class="font-weight-bold">Status:</span>
							{{ item.status }}</v-card-text
						>
						<v-card-text
							><v-select
								v-model="item.region"
								:items="item.region"
								label="Region"
								multiple
								chips
								disabled
							></v-select
							><v-select
								v-model="item.roles"
								:items="item.roles"
								label="Roles"
								multiple
								chips
								disabled
							></v-select
							><v-select
								v-model="item.shopType"
								:items="item.shopType"
								label="Shop Type"
								multiple
								chips
								disabled
							></v-select
						></v-card-text>
					</v-card>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-container>
		<v-dialog v-model="dialog" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline">{{
						isEdit ? "Edit Leaderboard" : "Add Leaderboard"
					}}</span>
				</v-card-title>
				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex xs12>
								<v-text-field
									label="Display Name"
									required
									@change="
										val =>
											handleFieldChange(
												val,
												'displayName',
												isEdit
											)
									"
									:value="payload.displayName"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									label="Leaderboard Name"
									required
									@change="
										val =>
											handleFieldChange(
												val,
												'leaderboardName',
												isEdit
											)
									"
									:value="payload.leaderboardName"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									label="Description"
									required
									@change="
										val =>
											handleFieldChange(
												val,
												'description',
												isEdit
											)
									"
									:value="payload.description"
								></v-text-field>
							</v-flex>
							<v-flex xs12>
								<v-text-field
									label="Frequency"
									required
									@change="
										val =>
											handleFieldChange(
												val,
												'frequency',
												isEdit
											)
									"
									type="number"
									:value="payload.frequency"
								></v-text-field>
							</v-flex>
						</v-layout>
						<v-select
							:items="[ACTIVE, INACTIVE]"
							label="Status"
							@change="
								val => handleFieldChange(val, 'status', isEdit)
							"
							:value="payload.status"
						></v-select>
						<v-select
							v-model="payload.region"
							:items="['all', ...states]"
							label="Region"
							multiple
							chips
							@change="
								val => handleFieldChange(val, 'region', isEdit)
							"
						></v-select
						><v-select
							v-model="payload.roles"
							:items="roles"
							label="Roles"
							multiple
							chips
							@change="
								val => handleFieldChange(val, 'roles', isEdit)
							"
						></v-select
						><v-select
							v-model="payload.shopType"
							:items="shopTypes"
							label="Shop Type"
							multiple
							chips
							@change="
								val =>
									handleFieldChange(val, 'shopType', isEdit)
							"
						></v-select>
					</v-container>
					<div class="pa-2">Start Time:</div>
					<div class="space">
						<v-date-picker
							@change="
								val => handleFieldChange(val, 'startD', isEdit)
							"
							v-model="(payload.startTime || '').split('T')[0]"
							width="250"
						></v-date-picker>
						<v-time-picker
							@change="
								val => handleFieldChange(val, 'startT', isEdit)
							"
							format="24hr"
							width="250"
							v-model="
								new Date(payload.startTime)
									.toTimeString()
									.split(' ')[0]
							"
						></v-time-picker>
					</div>
					<v-flex xs12 class="mt-4">
						<v-text-field
							label="Query SQL"
							required
							@change="
								val =>
									handleFieldChange(val, 'querySql', isEdit)
							"
							:value="(payload.query || {}).sql"
						></v-text-field>
					</v-flex>
					<div>Query Params:</div>
					<v-layout
						wrap
						v-for="(item, index) in isEdit ? editParams : addParams"
						:key="item.key"
					>
						<v-flex xs12 sm5 md5 class="mr-4">
							<v-text-field
								v-model="item.key"
								:label="`Key ${index + 1}`"
								@change="
									val =>
										handleFieldChange(
											val,
											'paramKey',
											isEdit,
											index
										)
								"
							></v-text-field>
						</v-flex>
						<v-flex xs11 sm5 md5>
							<v-text-field
								v-model="item.value"
								:label="`Value ${index + 1}`"
								@change="
									val =>
										handleFieldChange(
											val,
											'paramValue',
											isEdit,
											index
										)
								"
							></v-text-field>
						</v-flex>
						<v-flex>
							<v-icon
								small
								@click="
									(isEdit ? editParams : addParams).splice(
										index,
										1
									)
								"
							>
								delete
							</v-icon>
						</v-flex>
					</v-layout>
					<v-layout justify-center>
						<v-icon
							small
							class="mr-2"
							@click="
								(isEdit ? editParams : addParams).push({
									key: '',
									value: ''
								})
							"
						>
							add
						</v-icon></v-layout
					>
					<div>Prizes:</div>
					<v-layout
						wrap
						v-for="(item, index) in Object.keys(prizes || {})"
						:key="item"
					>
						<v-flex xs12 sm5 md5 class="mr-4">
							<v-text-field
								v-model="prizes[item].prize"
								:label="`Prize ${index + 1}`"
								@change="
									val =>
										handleFieldChange(
											val,
											'prizeValue',
											isEdit,
											item
										)
								"
							></v-text-field>
						</v-flex>
						<v-flex xs11 sm5 md5>
							<v-text-field
								v-model="prizes[item].image"
								:label="`Image ${index + 1}`"
								@change="
									val =>
										handleFieldChange(
											val,
											'prizeImage',
											isEdit,
											item
										)
								"
							></v-text-field>
						</v-flex>
						<v-flex>
							<v-icon small @click="deleteItemPrize(item)">
								delete
							</v-icon>
						</v-flex>
					</v-layout>
					<v-layout justify-center>
						<v-icon
							small
							@click="
								prizes = {
									...prizes,
									[Object.keys(prizes).length + 1]: {
										prize: '',
										image: ''
									}
								}
							"
						>
							add
						</v-icon></v-layout
					>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="error" flat @click="closeDialog">Close</v-btn>
					<v-btn color="success" flat @click="updateLeaderboard">{{
						isEdit ? "Update" : "Save"
					}}</v-btn>
				</v-card-actions>
			</v-card></v-dialog
		>
		<div v-if="isLoading" class="overlay">
			<v-progress-circular :indeterminate="true"></v-progress-circular>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import {
	FETCH_METRIC_LEADERBOARDS,
	UPSERT_METRIC_LEADERBOARDS,
	SHOW_ALERT
} from "../../store/action-types";

export default {
	name: "AddUpdateLeaderboard",
	props: ["title", "themeInputColor"],
	data() {
		return {
			leaderboardData: [],
			ACTIVE: "ACTIVE",
			INACTIVE: "INACTIVE",
			selectedStatus: "ACTIVE",
			isLoading: false,
			roles: [
				"all",
				"captain",
				"dstr",
				"dstrRetail",
				"executive",
				"promoter",
				"rbm",
				"tsm"
			],
			shopTypes: [
				"all",
				"shopboy",
				"agent",
				"outShop",
				"agency",
				"inShop"
			],
			dialog: false,
			isEdit: false,
			defaultPayload: {
				leaderboardName: "",
				displayName: "",
				description: "",
				status: "",
				roles: [],
				shopType: [],
				region: [],
				query: { sql: "" },
				startTime: new Date().toISOString(),
				frequency: "",
				prize: {}
			},
			payload: {},
			addParams: [],
			editParams: [],
			prizes: {}
		};
	},
	mounted() {
		this.fetchMetricLeaderboards(this.ACTIVE);
	},
	methods: {
		fetchMetricLeaderboards(status) {
			this.isLoading = true;
			this.$store
				.dispatch(FETCH_METRIC_LEADERBOARDS.dispatch, {
					status
				})
				.then(resp => {
					this.leaderboardData = resp;
					this.leaderboardData = this.leaderboardData.map(item => {
						if (item.prize) item.prize = JSON.parse(item.prize);
						if (item.query) item.query = JSON.parse(item.query);
						return item;
					});
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.isLoading = false;
				});
		},
		updateLeaderboard() {
			if (this.isEdit && this.editParams) {
				this.payload.query.params = JSON.parse(
					JSON.stringify(this.editParams)
				);
			}
			if (!this.isEdit && this.addParams) {
				this.payload.query.params = JSON.parse(
					JSON.stringify(this.addParams)
				);
			}
			this.payload.prize = this.prizes;
			delete this.payload.updatedOn;
			delete this.payload.mertics;
			const {
				leaderboardName,
				displayName,
				description,
				status,
				roles,
				shopType,
				region,
				query,
				frequency
			} = this.payload;
			if (
				!leaderboardName ||
				!displayName ||
				!description ||
				!status ||
				!roles ||
				!shopType ||
				!region ||
				!roles.length ||
				!shopType.length ||
				!region.length ||
				!query.sql ||
				!frequency
			) {
				this.$store.dispatch(SHOW_ALERT.dispatch, {
					text: "Please fill all details!!"
				});
				return;
			}
			this.payload.prize = JSON.stringify(this.payload.prize);
			this.payload.query = JSON.stringify(this.payload.query);
			this.isLoading = true;
			this.$store
				.dispatch(UPSERT_METRIC_LEADERBOARDS.dispatch, this.payload)
				.then(() => {
					this.closeDialog();
					this.fetchMetricLeaderboards(this.selectedStatus);
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.isLoading = false;
				});
		},
		handleStatusChange(status) {
			this.selectedStatus = status;
			this.fetchMetricLeaderboards(status);
		},
		openDialog(isEdit, item) {
			this.dialog = true;
			this.isEdit = isEdit;
			this.payload = JSON.parse(JSON.stringify(item));
			if (isEdit) {
				this.prizes = item.prize || {};
				this.editParams = JSON.parse(JSON.stringify(item.query.params));
			} else this.prizes = {};
		},
		closeDialog() {
			this.dialog = false;
			this.payload = JSON.parse(JSON.stringify(this.defaultPayload));
			this.isEdit = false;
			this.prizes = {};
			this.editParams = [];
			this.addParams = [];
		},
		handleFieldChange(value, type, isEdit, index) {
			const startTimeArray = this.payload.startTime.split("T");
			if (type === "startD")
				this.payload.startTime = new Date(
					`${value} ${startTimeArray[1]}`
				).toISOString();
			else if (type === "startT")
				this.payload.startTime = new Date(
					`${startTimeArray[0]} ${value}`
				).toISOString();
			else if (type === "querySql") this.payload.query.sql = value;
			else if (type === "paramKey") {
				(isEdit ? this.editParams : this.addParams)[index].key = value;
			} else if (type === "paramValue") {
				(isEdit ? this.editParams : this.addParams)[
					index
				].value = value;
			} else if (type === "prizeValue") this.prizes[index].prize = value;
			else if (type === "prizeImage") this.prizes[index].image = value;
			else this.payload[type] = value;
		},
		deleteItemPrize(item) {
			const newKeys = Object.keys(this.prizes).filter(
				prize => prize !== item
			);
			const newPrizes = {};
			newKeys.forEach(
				(key, index) => (newPrizes[index + 1] = this.prizes[key])
			);
			this.prizes = { ...newPrizes };
		}
	},
	computed: {
		...mapState({
			states: state => state.common.states
		})
	}
};
</script>

<style scoped>
.space {
	display: flex;
	justify-content: space-between;
}
.overlay {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 2;
}
</style>
